<template>
  <article
    ref="animatedElement"
    :class="`${props.data.color} p-6 min-h-[250px] lg:min-h-[380px] flex flex-col items-center justify-center text-center rounded`"
  >
    <h2 class="heading-md whitespace-pre-wrap">
      <span v-if="animatedNumber !== 0">{{ animatedNumber }}</span
      >{{ fixWhitespace(props.data.heading_text) }}
    </h2>
    <p class="body-lg">{{ props.data.text }}</p>
  </article>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'

const props = defineProps<{
  data: {
    color: string
    number: number
    heading_text: string
    text: string
  }
}>()

const animatedNumber = ref(props.data.number % 1 === 0 ? 0 : 0.0)
const animatedElement = ref<HTMLElement | null>(null)
let animationTriggered = false

const fixWhitespace = (text: string) => {
  return text.startsWith(' ') ? '\u00A0' + text.slice(1) : text
}

const animateValue = (start: number, end: number, duration: number) => {
  let startTime: number | null = null
  const isDecimal = end % 1 !== 0

  const step = (timestamp: number) => {
    if (startTime === null) startTime = timestamp
    const progress = Math.min((timestamp - startTime) / duration, 1)
    const currentValue = progress * (end - start) + start

    animatedNumber.value = isDecimal
      ? parseFloat(currentValue.toFixed(1))
      : Math.floor(currentValue)

    if (progress < 1) {
      window.requestAnimationFrame(step)
    }
  }
  window.requestAnimationFrame(step)
}

const startAnimation = () => {
  if (!animationTriggered) {
    animateValue(0, props.data.number, 2500)
    animationTriggered = true
  }
}

onMounted(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0]
      if (entry?.isIntersecting) {
        startAnimation()
        observer.disconnect()
      }
    },
    { threshold: 0.5 }
  )

  if (animatedElement.value) {
    observer.observe(animatedElement.value)
  }
})
</script>
<style></style>
